/* eslint-disable guard-for-in */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useParams } from 'react-router';
// import { enviroment } from '@utils/config';
import {
  useCallback, useEffect, useState, // useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import moment from 'moment';
// import createTokenProvider from '@utils/auth/createTokenProvider';

import telemetryApi from '@api/telemetryApi';
import devicesApi from '@api/devicesApi';
import { useTranslation } from 'react-i18next';
import telemetryFieldsInfo from '@utils/dictionaries/telemetryFields';
import telemetryActions from '../../state/telemetry/actions';
import telemetryConstants from '../../state/telemetry/constants';

// const { getToken } = createTokenProvider;

function useGraficasDispositivo() {

  // const { socketUrl } = enviroment;
  const history = useHistory();
  const { t } = useTranslation();
  const BreadcrumbTitle = t('menu_items.main.general_board');
  const { device } = useParams();
  const dispatch = useDispatch();
  const [deviceBusinessType, setDeviceBusinessType] = useState('');
  const [dataBusinessType, setDataBusinessType] = useState({});
  const [dataDevice, setDataDevice] = useState({});
  const generalInfo = useSelector(({ telemetry: tel }) => tel.generalDeviceInfo);

  const typeBatteryConsult = useSelector(({ telemetry }) => telemetry.typeConsultBattery);

  // eslint-disable-next-line max-len
  const consultAttributesBattery = useSelector(({ telemetry }) => telemetry.consultAttributeBattery);
  // eslint-disable-next-line max-len
  const typeBatteryConsultBoxPlot = useSelector(({ telemetry }) => telemetry.typeConsultBatteryBoxPlot);
  // eslint-disable-next-line max-len
  const dateConsultBatteryBoxPlot = useSelector(({ telemetry }) => telemetry.consultAttributeBatteryBoxPlot);

  const telemetryLastData = async ({
    fields, deviceName, deviceType, signal,
  }) => {

    const filters = {
      fields,
      deviceType,
      deviceName,
      initDate: encodeURIComponent(
        moment(moment().format('YYYY-MM-DD HH:00:00'))
          .subtract(15, 'minutes')
          .utcOffset('+00:00')
          .format('YYYY-MM-DD HH:mm:ss'),
      ),
      endDate: encodeURIComponent(
        moment(moment().format('YYYY-MM-DD HH:59:59'))
          .utcOffset('+00:00')
          .format('YYYY-MM-DD HH:mm:ss'),
      ),
      timeZone: encodeURIComponent('+00'),
    };

    try {

      const data = await telemetryApi.getGenericLastData({ signal, filters });
      return data;

    } catch (error) {

      return [];

    }

  };

  const telemetryIntervalData = async ({
    fields, deviceName, deviceType, signal, granularity, dateConsult,
  }) => {

    const filters = {
      fields,
      deviceType,
      deviceName,
      granularity: encodeURIComponent(granularity),
      initDate: encodeURIComponent(dateConsult[0]),
      endDate: encodeURIComponent(dateConsult[1]),
      timeZone: encodeURIComponent('+00'),
    };

    try {

      const data = await telemetryApi.getGenericGranularityData({ signal, filters });
      return data;

    } catch (error) {

      return [];

    }

  };

  const prepareData = ({
    valueArray, variable, granularity, modeValue,
  }) => {

    const units = telemetryFieldsInfo[variable];
    let operator = 0;
    if (units !== undefined) {

      operator = units.step;

    } else {

      operator = 1;

    }

    if (granularity === 'minute') {

      // return Math.abs(valueArray[variable.toLowerCase()]);
      if (valueArray[variable.toLowerCase()] >= 0) {

        return valueArray[variable.toLowerCase()] * operator;

      }

      return 0;

    }
    let formatType;
    if (granularity === 'day' || granularity === 'hour') {

      formatType = 'DD';

    } else if (granularity === 'month') {

      formatType = 'MM';

    } else {

      formatType = 'YYYY';

    }
    let data = {};
    if (valueArray[variable.toLowerCase()] >= 0) {

      if (modeValue === 'SUM') {

        data = {
          x: moment(valueArray.date).local().format(formatType),
          // y: Math.abs(valueArray[variable.toLowerCase()]),
          y: valueArray[variable.toLowerCase()] / 60000,
        };

      } else {

        data = {
          x: moment(valueArray.date).local().format(formatType),
          // y: Math.abs(valueArray[variable.toLowerCase()]),
          y: valueArray[variable.toLowerCase()],
        };

      }

    } else {

      data = {
        x: moment(valueArray.date).local().format(formatType),
        // y: Math.abs(valueArray[variable.toLowerCase()]),
        y: 0,
      };

    }

    return data;

  };

  const handleDeviceHome = () => {

    history.push(`/tablero-devices/${deviceBusinessType}`);

  };

  const infoDevice = useCallback((deviceId) => {

    const abortC = new AbortController();
    const { signal } = abortC;
    const id = deviceId;

    devicesApi.getDeviceId({ signal, id })
      .then((deviceApi) => {

        setDeviceBusinessType(deviceApi?.business_type?.id);
        setDataBusinessType(deviceApi?.business_type);

        const arrDevicesType = deviceApi?.device_types.map((item) => item.name) || [];

        const itemDevice = {
          client: deviceApi.client,
          name: deviceApi.name,
          mac: deviceApi?.gateway?.mac || '',
          business: deviceApi?.business_type?.name || '',
          gateway: deviceApi?.gateway?.name || '',
          slvId: deviceApi?.slvId || '',
          firmware: deviceApi?.firmware || '',
          device_types: arrDevicesType.join(', '),
        };

        dispatch(telemetryActions.setGeneralDeviceInfo(itemDevice));

      }).catch((error) => {

        console.log('error ', error);

      });

  }, [dispatch]);

  const infoSystem = useCallback((deviceId) => {

    const abortC = new AbortController();
    const { signal } = abortC;
    const id = deviceId;

    try {

      devicesApi.getDeviceId({ id, signal })
        .then(async (deviceApi) => {

          const variablesInfoSystem = [
            'pPT',
            'ImPT',
            'PLdT',
            'DisP',
            'ExPT',
            'SOC',
            'ImET',
            'DisET',
            'ChET',
            'ExET',
            'LConT',
            'ChrP',
            'pET',
            'AConT',
          ];

          const statusSystemInfo = [];
          // Preguntar si es necesario o como tomar generalStatusPriority
          // const types = ['solar', 'grid', 'consumption', 'battery'];
          /* const statusSystemInfo = await inverterStatus({
          deviceModel: inverter.device.name,
          inverterModel: inverter_model.name,
          typeEvent: 'Pri',
        }); */

          let generalStatusPriority;
          if (statusSystemInfo.length > 0) {

            generalStatusPriority = statusSystemInfo[0].description;

          } else {

            generalStatusPriority = 'NA';

          }

          const fieldsArray = await Promise.all(deviceApi?.device_types?.map(async (obj) => {

            const data = await telemetryApi.getAllDeviceField({ signal, device_type: obj.id });
            const dataVariable = await data.map((item) => item.edge_name);
            return { ...obj, field: dataVariable };

          }));

          // validar si estas propiedades existen en los devices_type
          const validFieldsSolar = ['pPT', 'pET'];
          const validFieldsBattery = ['DisP', 'SOC', 'DisET', 'ChET', 'ChrP'];
          const validFieldsGrid = ['ImPT', 'ExPT', 'ImET', 'ExET'];
          const validFieldsConsumption = ['PLdT', 'LConT', 'AConT'];

          const fieldsSolar = [];
          const fieldsBattery = [];
          const fieldsGrid = [];
          const fieldsConsumption = [];

          let device_type_solar = '';
          let device_type_battery = '';
          let device_type_grid = '';
          let device_type_consumption = '';

          fieldsArray.forEach((item) => {

            const { field } = item;
            validFieldsSolar.forEach((itemValid) => {

              if (field.indexOf(itemValid) > -1) {

                fieldsSolar.push(itemValid);
                device_type_solar = item.id;

              }

            });

            validFieldsBattery.forEach((itemValid) => {

              if (field.indexOf(itemValid) > -1) {

                fieldsBattery.push(itemValid);
                device_type_battery = item.id;

              }

            });

            validFieldsGrid.forEach((itemValid) => {

              if (field.indexOf(itemValid) > -1) {

                fieldsGrid.push(itemValid);
                device_type_grid = item.id;

              }

            });

            validFieldsConsumption.forEach((itemValid) => {

              if (field.indexOf(itemValid) > -1) {

                fieldsConsumption.push(itemValid);
                device_type_consumption = item.id;

              }

            });

          });

          const dataFields = [{
            solar: fieldsSolar,
            grid: fieldsGrid,
            battery: fieldsBattery,
            consumption: fieldsConsumption,
          }];

          let stringSolar = '';
          let stringBattery = '';
          let stringGrid = '';
          let stringConsumption = '';

          if (dataFields[dataFields.length - 1].solar.length > 0) {

            const len = dataFields[dataFields.length - 1].solar.length;
            for (let i = 0; i < len; i += 1) {

              stringSolar += `&field=${dataFields[dataFields.length - 1].solar[i]}`;

            }

          }

          if (dataFields[dataFields.length - 1].grid.length > 0) {

            const len = dataFields[dataFields.length - 1].grid.length;
            for (let i = 0; i < len; i += 1) {

              stringGrid += `&field=${dataFields[dataFields.length - 1].grid[i]}`;

            }

          }

          if (dataFields[dataFields.length - 1].battery.length > 0) {

            const len = dataFields[dataFields.length - 1].battery.length;
            for (let i = 0; i < len; i += 1) {

              stringBattery += `&field=${dataFields[dataFields.length - 1].battery[i]}`;

            }

          }

          if (dataFields[dataFields.length - 1].consumption.length > 0) {

            const len = dataFields[dataFields.length - 1].consumption.length;
            for (let i = 0; i < len; i += 1) {

              stringConsumption += `&field=${dataFields[dataFields.length - 1].consumption[i]}`;

            }

          }

          let dataSolar = [];
          let dataBattery = [];
          let dataGrid = [];
          let dataConsumption = [];

          if (stringBattery !== '') {

            dataBattery = await telemetryLastData({
              fields: stringBattery,
              signal,
              deviceName: deviceApi?.gateway?.mac,
              deviceType: device_type_battery,
            });

          }

          if (stringSolar !== '') {

            dataSolar = await telemetryLastData({
              fields: stringSolar,
              signal,
              deviceName: deviceApi?.gateway?.mac,
              deviceType: device_type_solar,
            });

          }

          if (stringGrid !== '') {

            dataGrid = await telemetryLastData({
              fields: stringGrid,
              signal,
              deviceName: deviceApi?.gateway?.mac,
              deviceType: device_type_grid,
            });

          }

          if (stringConsumption !== '') {

            dataConsumption = await telemetryLastData({
              fields: stringConsumption,
              signal,
              deviceName: deviceApi?.gateway?.mac,
              deviceType: device_type_consumption,
            });

          }

          // eslint-disable-next-line max-len
          if (dataSolar.length > 0 && dataGrid.length > 0 && dataBattery.length > 0 && dataConsumption.length > 0) {

            // eslint-disable-next-line max-len
            const dataSystem = variablesInfoSystem.map((value) => {

              const indexSolar = dataFields[dataFields.length - 1].solar.indexOf(value);
              const indexGrid = dataFields[dataFields.length - 1].grid.indexOf(value);
              const indexBattery = dataFields[dataFields.length - 1].battery.indexOf(value);

              if (indexSolar >= 0) {

                return dataSolar[0][value.toLowerCase()];

              }
              if (indexGrid >= 0) {

                return dataGrid[0][value.toLowerCase()];

              }
              if (indexBattery >= 0) {

                return dataBattery[0][value.toLowerCase()];

              }

              return dataConsumption[0][value.toLowerCase()];

            });

            // console.log('dataSolar ', dataSolar);
            // console.log('dataGrid ', dataGrid);
            // console.log('dataBattery ', dataBattery);
            // console.log('dataConsumption ', dataConsumption);

            // console.log(' dataSystem ', dataSystem);

            let statusBattery;
            let batteryValue;
            let gridValue;
            let gridStatus;
            if (dataSystem[11] / 1000 >= 0.001) {

              batteryValue = (dataSystem[11] / 1000).toFixed(2);
              statusBattery = 'Cargando';

            } else if (((dataSystem[3]) / 1000) >= 0.001) {

              batteryValue = (dataSystem[3] / 1000).toFixed(2);
              statusBattery = 'Descargando';

            } else {

              batteryValue = 0;
              statusBattery = 'Reposo';

            }

            if (dataSystem[1] > 0) {

              // eslint-disable-next-line prefer-destructuring
              gridValue = dataSystem[1];
              gridStatus = 'Importando';

            } else if (dataSystem[4] > 0) {

              // eslint-disable-next-line prefer-destructuring
              gridValue = dataSystem[4];
              gridStatus = 'Exportando';

            } else {

              gridValue = 0;
              gridStatus = 'Reposo';

            }

            const infoSystemData = {
              systemStatus: 'On Grid',
              mode: generalStatusPriority,
              solarPower: (dataSystem[0] / 1000).toFixed(2),
              socBattery: dataSystem[5],
              statusBattery,
              batteryValue,
              // eslint-disable-next-line max-len
              loadConsumption: (dataSystem[2] / 1000).toFixed(2),
              powerGrid: (gridValue / 1000).toFixed(2),
              gridStatus,
            };

            const generalStatistics = {
              importEnergy: parseFloat(dataSystem[6]?.toFixed(0) || 0),
              dischargeEnergy: parseFloat(dataSystem[7]?.toFixed(0) || 0),
              storageEnergy: parseFloat(dataSystem[8]?.toFixed(0) || 0),
              energyGenerated: parseFloat(
                dataSystem[12]?.toFixed(0) || 0,
              ),
              energySelfConsumption: parseFloat(Math.abs(dataSystem[13]).toFixed(0)),
              exportEnergy: parseFloat(dataSystem[9].toFixed(0)),
              consumptionEnergy: parseFloat(
                dataSystem[10]?.toFixed(0) || 0,
              ),
            };

            dispatch(telemetryActions.setGeneralStatistics(generalStatistics));
            dispatch(telemetryActions.setInfoSystem(infoSystemData));

          } else {

            // Limpiar formato
            dispatch(telemetryActions.setGeneralStatistics({
              importEnergy: 0,
              dischargeEnergy: 0,
              storageEnergy: 0,
              CO2: 0,
              exportEnergy: 0,
              consumptionEnergy: 0,
              energySelfConsumption: 0,
              energyGenerated: 0,
            }));

            // Limpiar formato
            dispatch(telemetryActions.setInfoSystem({
              systemStatus: '',
              mode: '',
              solarPower: 0,
              socBattery: 0,
              statusBattery: '',
              loadConsumption: 0,
              powerGrid: 0,
              gridStatus: '',
            }));

          }

        });

    } catch (error) {

      console.log('infoSystem ', error);

    }

  });

  const loadInfoSystem = useCallback((deviceId) => {

    dispatch(telemetryActions.setLoadingInfoSystem(true));
    infoSystem(deviceId);

  }, [dispatch]);

  const dataGraphBattery = useCallback((deviceId) => {

    dispatch(telemetryActions.setLoadingGraphBattery(true));
    const abortC = new AbortController();
    const { signal } = abortC;
    const id = deviceId;

    let variablesInfoSystem;
    let typeGraph;
    let granularity;
    let variablesData;
    let units;

    if (typeBatteryConsult === telemetryConstants.BATTERY_CONSULT) {

      variablesInfoSystem = ['DisET', 'ChET'];
      variablesData = {
        solar: [],
        grid: [],
        battery: ['DisET', 'ChET'],
        consumption: [],
      };
      typeGraph = 'bar';
      granularity = 'hour';
      units = 'kWh';

    } else {

      variablesInfoSystem = ['SOC'];
      typeGraph = 'area';
      granularity = 'minute';
      units = '%';
      variablesData = {
        solar: [],
        grid: [],
        battery: ['SOC'],
        consumption: [],
      };

    }

    devicesApi.getDeviceId({ id, signal })
      .then(async (deviceApi) => {

        const fieldsArray = await Promise.all(deviceApi?.device_types?.map(async (obj) => {

          const data = await telemetryApi.getAllDeviceField({ signal, device_type: obj.id });
          const dataVariable = await data.map((item) => item.edge_name);
          const dataVariableName = await data.map((item) => item.name);
          return { ...obj, field: dataVariable, fieldName: dataVariableName };

        }));

        const fieldsSolar = [];
        const fieldsBattery = [];
        const fieldsGrid = [];
        const fieldsConsumption = [];

        let device_type_solar = '';
        let device_type_battery = '';
        let device_type_grid = '';
        let device_type_consumption = '';

        const labelData = [];

        fieldsArray.forEach((item) => {

          const { field, fieldName } = item;
          variablesData.solar.forEach((itemValid) => {

            if (field.indexOf(itemValid) > -1) {

              fieldsSolar.push(itemValid);
              device_type_solar = item.id;
              labelData.push(fieldName[field.indexOf(itemValid)]);

            }

          });

          variablesData.battery.forEach((itemValid) => {

            if (field.indexOf(itemValid) > -1) {

              fieldsBattery.push(itemValid);
              device_type_battery = item.id;
              labelData.push(fieldName[field.indexOf(itemValid)]);

            }

          });

          variablesData.grid.forEach((itemValid) => {

            if (field.indexOf(itemValid) > -1) {

              fieldsGrid.push(itemValid);
              device_type_grid = item.id;
              labelData.push(fieldName[field.indexOf(itemValid)]);

            }

          });

          variablesData.consumption.forEach((itemValid) => {

            if (field.indexOf(itemValid) > -1) {

              fieldsConsumption.push(itemValid);
              device_type_consumption = item.id;
              labelData.push(fieldName[field.indexOf(itemValid)]);

            }

          });

        });

        const dataFields = [{
          solar: fieldsSolar,
          grid: fieldsGrid,
          battery: fieldsBattery,
          consumption: fieldsConsumption,
        }];

        let stringSolar = '';
        let stringBattery = '';
        let stringGrid = '';
        let stringConsumption = '';

        if (dataFields[dataFields.length - 1].solar.length > 0) {

          const len = dataFields[dataFields.length - 1].solar.length;
          for (let i = 0; i < len; i += 1) {

            stringSolar += `&field=${dataFields[dataFields.length - 1].solar[i]}`;

          }

        }

        if (dataFields[dataFields.length - 1].grid.length > 0) {

          const len = dataFields[dataFields.length - 1].grid.length;
          for (let i = 0; i < len; i += 1) {

            stringGrid += `&field=${dataFields[dataFields.length - 1].grid[i]}`;

          }

        }

        if (dataFields[dataFields.length - 1].battery.length > 0) {

          const len = dataFields[dataFields.length - 1].battery.length;
          for (let i = 0; i < len; i += 1) {

            stringBattery += `&field=${dataFields[dataFields.length - 1].battery[i]}`;

          }

        }

        if (dataFields[dataFields.length - 1].consumption.length > 0) {

          const len = dataFields[dataFields.length - 1].consumption.length;
          for (let i = 0; i < len; i += 1) {

            stringConsumption += `&field=${dataFields[dataFields.length - 1].consumption[i]}`;

          }

        }

        let dataSolar = [];
        let dataBattery = [];
        let dataGrid = [];
        let dataConsumption = [];

        const initDate = moment(moment().format('YYYY-MM-DD 00:00:00'))
          .subtract(7, 'days')
          .utcOffset('+00:00')
          .format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment(moment().format('YYYY-MM-DD 23:59:59'))
          .utcOffset('+00:00')
          .format('YYYY-MM-DD HH:mm:ss');

        const dateConsult = [];

        dateConsult.push(initDate);
        dateConsult.push(endDate);

        if (stringBattery !== '') {

          dataBattery = await telemetryIntervalData({
            fields: stringBattery,
            signal,
            deviceName: deviceApi?.gateway?.mac,
            deviceType: device_type_battery,
            granularity,
            dateConsult,
          });

        }

        if (stringSolar !== '') {

          dataSolar = await telemetryIntervalData({
            fields: stringSolar,
            signal,
            deviceName: deviceApi?.gateway?.mac,
            deviceType: device_type_solar,
            granularity,
            dateConsult,
          });

        }

        if (stringGrid !== '') {

          dataGrid = await telemetryIntervalData({
            fields: stringGrid,
            signal,
            deviceName: deviceApi?.gateway?.mac,
            deviceType: device_type_grid,
            granularity,
            dateConsult,
          });

        }

        if (stringConsumption !== '') {

          dataConsumption = await telemetryIntervalData({
            fields: stringConsumption,
            signal,
            deviceName: deviceApi?.gateway?.mac,
            deviceType: device_type_consumption,
            granularity,
            dateConsult,
          });

        }

        if (typeBatteryConsult === telemetryConstants.BATTERY_CONSULT) {

          const dataUtcAdjust = dataBattery.map((value) => {

            const date = moment
              .utc(value.date)
              .local()
              .format('YYYY-MM-DD HH:mm:ss');

            return {
              ...value,
              date,
            };

          });

          const differenceDays = moment(endDate).diff(moment(initDate), 'days');
          const listDates = [];

          for (let i = 0; i <= differenceDays; i += 1) {

            listDates.push(moment(moment
              .utc(initDate)
              .local()
              .format('YYYY-MM-DD HH:mm:ss')).add(i, 'days').format('YYYY-MM-DD HH:mm:ss'));

          }
          const dataBatteryMaxValues = [];

          let chEnd = 0;
          let desEnd = 0;
          const currentDate = moment().format('YYYY-MM-DD HH:00:00');
          listDates.map((date) => {

            const data = dataUtcAdjust.map((value) => {

              if (moment(date).format('YYYY-MM-DD 23:00:00') === value.date) {

                chEnd = value.chet;
                desEnd = value.diset;
                dataBatteryMaxValues.push({
                  date,
                  chet: chEnd,
                  diset: desEnd,
                });
                return 0;

              }
              if (currentDate === value.date && moment(date).format('YYYY-MM-DD') === moment(currentDate).format('YYYY-MM-DD')) {

                chEnd = value.chet;
                desEnd = value.diset;
                dataBatteryMaxValues.push({
                  date,
                  chet: chEnd,
                  diset: desEnd,
                });
                return 0;

              }
              return 0;

            });
            return data;

          });

          const dataBatteryOperation = dataBatteryMaxValues.map((value, index) => {

            let dataChet = 0;
            let dataDiset = 0;
            if (dataBatteryMaxValues[index + 1] !== undefined) {

              dataChet = parseFloat((dataBatteryMaxValues[index + 1].chet - value.chet).toFixed(1));
              // eslint-disable-next-line max-len
              dataDiset = parseFloat((dataBatteryMaxValues[index + 1].diset - value.diset).toFixed(1));

            }

            return {
              date: moment(value.date).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
              chet: dataChet,
              diset: dataDiset,
            };

          });

          dataBattery = dataBatteryOperation.splice(0, (dataBatteryOperation.length - 1));

        }

        if (dataBattery.length >= 0) {

          // eslint-disable-next-line max-len
          const graphData = variablesInfoSystem.map(
            // eslint-disable-next-line max-len
            (value) => {

              const indexSolar = dataFields[dataFields.length - 1].solar.indexOf(value);
              const indexGrid = dataFields[dataFields.length - 1].grid.indexOf(value);
              const indexBattery = dataFields[dataFields.length - 1].battery.indexOf(value);

              if (indexSolar >= 0) {

                return dataSolar.map((valueArray) => prepareData({
                  valueArray,
                  granularity,
                  variable: value,
                }));

              }
              if (indexGrid >= 0) {

                return dataGrid.map((valueArray) => prepareData({
                  valueArray,
                  granularity,
                  variable: value,
                }));

              }
              if (indexBattery >= 0) {

                return dataBattery.map((valueArray) => prepareData({
                  valueArray,
                  granularity,
                  variable: value,
                }));

              }

              return dataConsumption.map((valueArray) => prepareData({
                valueArray,
                granularity,
                variable: value,
              }));

            },
          );

          // eslint-disable-next-line max-len
          // const dates = telemetryData[0].map((valueArray) => moment
          //   .utc(valueArray.date)
          //   .local()
          //   .format('YYYY-MM-DD HH:mm:ss'));
          let dates = [];
          if (dataSolar.length > 0) {

            dates = dataSolar.map((valueArray) => moment
              .utc(valueArray.date)
              .local()
              .format('YYYY-MM-DD HH:mm:ss'));

          } else if (dataBattery.length > 0) {

            if (typeBatteryConsult === telemetryConstants.BATTERY_CONSULT) {

              dates = dataBattery.map((valueArray) => moment(valueArray.date)
                .format('YYYY-MM-DD HH:mm:ss'));

            } else {

              dates = dataBattery.map((valueArray) => moment(valueArray.date)
                .utc(valueArray.date)
                .local()
                .format('YYYY-MM-DD HH:mm:ss'));

            }

          } else if (dataGrid.length > 0) {

            dates = dataGrid.map((valueArray) => moment
              .utc(valueArray.date)
              .local()
              .format('YYYY-MM-DD HH:mm:ss'));

          } else {

            dates = dataConsumption.map((valueArray) => moment
              .utc(valueArray.date)
              .local()
              .format('YYYY-MM-DD HH:mm:ss'));

          }
          // const dates = telemetryData[0].map((valueArray) => valueArray.date);
          const graphDataComponent = {
            graphData,
            dates,
            typeGraph,
            labels: labelData,
            units,
          };

          dispatch(telemetryActions.setGraphBattery(graphDataComponent));

        }

      });

  }, [typeBatteryConsult, dispatch]);

  const dataGraphBatteryBoxPlot = useCallback((deviceId) => {

    dispatch(telemetryActions.setLoadingGraphBatteryBoxPlot(true));
    const abortC = new AbortController();
    const { signal } = abortC;
    const id = deviceId;

    let telemetryData;
    let typeGraph;
    let labels;
    let filters;

    const { dateConsult } = consultAttributesBattery;
    devicesApi.getDeviceId({ id, signal })
      .then(async (deviceApi) => {

        if (typeBatteryConsultBoxPlot === telemetryConstants.BOX_CONSULT) {

          filters = {
            device: deviceApi.name,
            initDate: encodeURIComponent(
              moment(dateConsultBatteryBoxPlot.dateConsult[0]).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
            ),
            endDate: encodeURIComponent(
              moment(dateConsultBatteryBoxPlot.dateConsult[1]).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
            ),
          };

          try {

            telemetryData = await telemetryApi.getBoxplotGraphDevice({ filters, signal });

          } catch (error) {

            telemetryData = [];

          }

          typeGraph = 'boxPlot';
          labels = ['State Battery'];

        } else {

          filters = {
            device: deviceApi.name,
            initDate: encodeURIComponent(dateConsult[0]),
            endDate: encodeURIComponent(dateConsult[1]),
          };

          try {

            telemetryData = await telemetryApi.getDODGraphDevice({ filters, signal });

          } catch (error) {

            telemetryData = [];

          }

          typeGraph = 'bar';
          labels = ['DOD'];

        }

        if (telemetryData) {

          let graphData;
          const categories = [];

          if (typeBatteryConsultBoxPlot === telemetryConstants.BOX_CONSULT) {

            graphData = telemetryData.map((value) => {

              const data = {
                x: moment(value.day_time).format('YYYY-MM-DD'),
                y: [0, value.second_quartile, value.median, value.third_quartile, 100],
              };

              return data;

            });
            graphData.splice((graphData.length - 1), 1);

          } else {

            graphData = [];

            const keys = Object.keys(telemetryData);
            const values = Object.values(telemetryData);
            for (let i = 0; i < keys.length; i += 1) {

              if (keys[i] !== 'total') {

                categories.push(keys[i]);
                graphData.push(values[i]);

              }

            }
            graphData = graphData.reverse();

          }

          const graphDataComponent = {
            graphData,
            typeGraph,
            labels,
            categories,
          };

          dispatch(telemetryActions.setGraphBatteryBoxPLot(graphDataComponent));

        }

      });

  }, [typeBatteryConsultBoxPlot, consultAttributesBattery, dispatch, dateConsultBatteryBoxPlot]);

  useEffect(() => {

    infoDevice(device);
    loadInfoSystem(device);

    const interval = setInterval(() => {

      infoSystem(device);

    }, 30000);
    return () => clearInterval(interval);

  }, [device]);

  useEffect(() => {

    dataGraphBattery(device);

  }, [typeBatteryConsult, dataGraphBattery, device]);

  useEffect(() => {

    setDataDevice(generalInfo);

  }, [generalInfo]);

  useEffect(() => {

    dataGraphBatteryBoxPlot(device);

  }, [typeBatteryConsultBoxPlot, consultAttributesBattery, dataGraphBatteryBoxPlot, device]);

  return {
    device,
    dataDevice,
    BreadcrumbTitle,
    handleDeviceHome,
    dataBusinessType,
  };

}

export default useGraficasDispositivo;
